// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Injectable } from '@movecloser/front-core';
import { EModal } from '@contract/modal';
let ReactionsService = class ReactionsService {
    constructor(reactionsRepository, modalConnectorService, authService) {
        this.reactionsRepository = reactionsRepository;
        this.modalConnector = modalConnectorService;
        this.authService = authService;
    }
    async toggleLike(type, contentId) {
        if (!this.authService.check()) {
            this.modalConnector.open(EModal.LogIn);
            return;
        }
        try {
            return await this.reactionsRepository.toggleLike(type, contentId);
        }
        catch (e) {
            console.error(e);
        }
    }
};
ReactionsService = __decorate([
    Injectable()
], ReactionsService);
export { ReactionsService };
